import CrudTable from '../../crud/CrudTable'
import { usercompaniesService as service } from '../../../services'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'

const initFilter = {
    name: null,
    lastname: null,
    email: null,
    phone: null,
    acceptByCompany: 4,
    acceptByUser: 4,
}

export default function Users() {
    const createEstructureFilter = [
        {
            type: 'input',
            name: 'nif',
            col: 4,
        },
        {
            type: 'input',
            name: 'name',
            col: 4,
        },
        {
            type: 'input',
            name: 'lastname',
            col: 4,
        },
        {
            type: 'input',
            name: 'email',
            col: 4,
        },
        {
            type: 'autocomplete',
            name: 'acceptByCompany',
            options: [
                { key: '1', name: 'Si' },
                { key: '2', name: 'No' },
                { key: '3', name: 'Pendientes' },
                { key: '4', name: 'Todos' },
            ],
            col: 4,
        },
        {
            type: 'autocomplete',
            name: 'acceptByUser',
            options: [
                { key: '1', name: 'Si' },
                { key: '2', name: 'No' },
                { key: '3', name: 'Pendientes' },
                { key: '4', name: 'Todos' },
            ],
            col: 4,
        },
    ]

    const paintCell = {
        username: (value, object) => {
            return object['user'] != null && object['user']['email'] != null ? (
                <>
                    {object['user']['email']} <br />
                    {object['user']['name'] ?? ''} <br />
                    {object['user']['lastname'] ?? ''} <br />
                </>
            ) : (
                <>Aún sin registrar en Mobify</>
            )
        },
        acceptByCompany: (value, object) => {
            if (value == null) {
                return <HourglassEmptyIcon />
            } else if (value) {
                return <CheckIcon style={{ color: 'green' }} />
            } else {
                return <ClearIcon style={{ color: 'red' }} />
            }
        },
        acceptByUser: (value, object) => {
            if (value == null) {
                return <HourglassEmptyIcon />
            } else if (value) {
                return <CheckIcon style={{ color: 'green' }} />
            } else {
                return <ClearIcon style={{ color: 'red' }} />
            }
        },
    }

    return (
        <CrudTable
            service={service}
            urledit={'/users/edit/'}
            urlnew={'/users/new/'}
            filter={initFilter}
            paintCell={paintCell}
            deleteaction={false}
            i18n={'usertocompany'}
            notexport={true}
            fieldstable={[
                'nifUser',
                'username',
                'acceptByCompany',
                'acceptByUser',
                'dateEnd',
            ]}
            labels={{ username: 'Usuario' }}
            estructureForm={createEstructureFilter}
        />
    )
}
